import React from "react";
import StatusCard from "../Cards/StatusCard";
import AddNewButton from "../Buttons/AddNewButton";

const DetailsPageHead = (props)=> {
    return(
        <div className="max-w-screen-xl mx-auto">
            <div className="flex items-center justify-between  binhead">
                <h3 className="mb-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white">{props.pageDetHeading}</h3>
                <div className="flex gap-x-3.5">
                    <div className="">
                        <AddNewButton innerTxt={"View On Map"}/>
                    </div>

                    <div className="">
                        <AddNewButton innerTxt={"Change Status"}/>
                    </div>

                    <div className="">
                        <AddNewButton innerTxt={"Delete"}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DetailsPageHead